import React from "react";
import { withRouter } from "react-router-dom";

const PageNavbar = ({ history, title, home = false, transparent = false }) => (
  <nav
    className={`navbar portal-navbar portal-navbar--page${
      transparent ? " portal-navbar--transparent" : ""
    } d-flex align-items-center justify-content-between`}
    aria-label={`${title || "Page"} navigation`}
  >
    <button
      type="button"
      className="navbar-icon-button"
      onClick={() => (home ? history.push("/") : history.goBack())}
      aria-label={home ? "Back to home" : "Go back"}
    >
      <i className="fas fa-arrow-left" aria-hidden="true" />
    </button>

    <span className="portal-navbar__title">{title}</span>
    <span className="portal-navbar__spacer" aria-hidden="true" />
  </nav>
);

export default withRouter(PageNavbar);
